import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SolicitudAtestFitoProductosViewModel, TProductoSolicitudAtestFitoViewModel } from './productosAtestFito.types';
import { Tc } from '../../../core/_infrastructure/types/common';


@Injectable()
export class ProductosAtestFitoService {

   
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {


    }    

    getSolicitudProductosAtestFito(id: number): Observable<SolicitudAtestFitoProductosViewModel> {
        return this.http
            .get<SolicitudAtestFitoProductosViewModel>(this.baseUrl + 'api/exportacion/atestaciones/productoAtest/' + id).pipe();
    }

    getProductoAtestFito(id: number): Observable<TProductoSolicitudAtestFitoViewModel> {
        return this.http
            .get<TProductoSolicitudAtestFitoViewModel>(this.baseUrl + 'api/exportacion/atestaciones/productoAtest/productoAtest/' + id).pipe();
    }

    editSolicitudProductosAtestFito(solicitud: SolicitudAtestFitoProductosViewModel): Observable<any> {
        return this.http
            .put<SolicitudAtestFitoProductosViewModel>(this.baseUrl + 'api/exportacion/atestaciones/productoAtest/SaveSolicitudProductos', solicitud).pipe();
    }

    createProductoAtestFito(producto: TProductoSolicitudAtestFitoViewModel): Observable<any> {
        return this.http
            .post<TProductoSolicitudAtestFitoViewModel>(this.baseUrl + 'api/exportacion/atestaciones/productoAtest', producto).pipe();
    }

    editProductoAtestFito(producto: TProductoSolicitudAtestFitoViewModel): Observable<any> {
        return this.http
            .put<TProductoSolicitudAtestFitoViewModel>(this.baseUrl + 'api/exportacion/atestaciones/productoAtest', producto).pipe();
    }

    deleteSolicitudProductosAtestFito(id: number): Observable<any> {
        return this.http
            .delete<TProductoSolicitudAtestFitoViewModel>(this.baseUrl + 'api/exportacion/atestaciones/productoAtest/' + id).pipe();
    }
   
    getParcelasSolicitudProductos(id: number): Observable<Tc[]> {
        return this.http
            .get<Tc[]>(this.baseUrl + 'api/exportacion/atestaciones/productoAtest/parcelas/' + id).pipe();
    }

    getGruposByAcCa(id: number): Observable<Tc[]> {
        return this.http
            .get<Tc[]>(this.baseUrl + 'api/exportacion/atestaciones/productoAtest/gruposByAcCa/' + id).pipe();
    }

    getFormasByAcCa(params: HttpParams): Observable<Tc[]> {
        return this.http
            .get<Tc[]>(this.baseUrl + 'api/exportacion/atestaciones/productoAtest/formasByAcCa/', { params: params }).pipe();
    }

}
